import { render, staticRenderFns } from "./buttonBean.vue?vue&type=template&id=86f8d9fc&"
import script from "./buttonBean.vue?vue&type=script&lang=js&"
export * from "./buttonBean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports